import './bootstrap';
import './app-edp.css';
import 'lazysizes/plugins/bgset/ls.bgset';

import sso from '~/components/sso/sso';
import { onDomReady, onPageFullyLoaded } from '~/load-components';

sso.init();

document.addEventListener('DOMContentLoaded', onDomReady, false);
window.addEventListener('load', onPageFullyLoaded, false);
